import { ca } from '@cian/analytics';
import { TLabel } from '../../types/auth';

export function trackButtonClick(label: TLabel) {
  ca('eventSite', {
    action: 'send',
    label,
    category: 'Mortgage',
    name: 'oldevent',
  });
}

export function trackShowInput(label: TLabel) {
  ca('eventSite', {
    action: 'show',
    label,
    category: 'Mortgage',
    name: 'oldevent',
  });
}

export function trackStartInput(label: TLabel) {
  ca('eventSite', {
    action: 'input',
    label,
    category: 'Mortgage',
    name: 'oldevent',
  });
}
